<ng-container *ngIf="insurers.length > 0">
  <ng-container *ngFor="let insurer of insurers; let i = index">
    <div class="col-xs-12 col-md-6" id="divInsurer2">
      <h3 class="section-title">Datos del asegurado {{ insurer.number }}</h3>
      <div class="form-control input">
        <input
          type="tel"
          name="dob{{ insurer.number }}"
          id="txtDate{{ insurer.number }}"
          spellcheck="false"
          placeholder="dd/mm/aaaa"
          class="text-input inline text-09-d-demibold txtBirthDate"
          inputmode="numeric"
          [value]="insurer.date"
          appDateMask
         (valueChange)="onDateChange($event, insurer, i)">
          
        <p class="error-txt">Para continuar, introduce una fecha</p>
      </div>
    </div>
  </ng-container>
</ng-container>